import React from 'react'

export default function About() {
    return (
        <main className="Futha-main">
            <div className="content about">
                <h1>About</h1>
                <p className="justify">
                    The Elder Futhark, Elder Fuþark, Older Futhark, Old Futhark or Germanic Futhark is the oldest form of the runic alphabets. It was a writing system used by Germanic tribes for Northwest Germanic dialects in the Migration Period, the dates of which are debated among scholars. Runic inscriptions are found on artifacts, including jewelry, amulets, plateware, tools, weapons, and, famously, runestones, from the 2nd to the 8th centuries. [<a href="https://en.wikipedia.org/wiki/Elder_Futhark" target="blank">Wikipedia</a>]
                </p>

                <p>This project was strongly inspired by the work done by <a href="http://www.wardruna.com" target="blank">Wardruna</a> - Einar Selvik and Lindy Fay Hella - and  <a href="https://heilung.bandcamp.com/" target="blank">Heilung</a> - Kai Uwe Faust, Maria Franz and Christopher Juul. </p>

                <p>Wardruna is a Norwegian music group formed in 2003. They are dedicated to creating musical renditions of Norse cultural and make significant use of Nordic historical and traditional instruments.</p>

                <p>Heilung is amplified history from early medieval northern Europe and should not be mistaken for a modern political or religious statement of any kind. Heilung is sounds from the northern european iron age and viking period.</p>


                <p>ᚠᚢᚦᚨ (Futha) was created using <a href="https://reactjs.org/">React</a>, <a href="https://getbootstrap.com/" target="blank">Bootstrap</a>, <a href="https://github.com/Wufe/react-particles-js" target="blank">React Particles</a> and the Futha module. The source code is published on Github.</p>
            </div>
        </main>
    )
}
